import { useEffect, useState } from 'react';
import VideoFallback from '../../assets/images/video-unavailable.png';

interface IProps {
  videoUrl: string;
  fallbackImage?: string;
  className?: string;
}

const VideoWithFallback = ({ videoUrl, fallbackImage = '', className }: IProps) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [videoUrl]);
  return (
    <>
      {hasError ? (
        <div className="tw-text-center tw-h-full">
          <img
            src={fallbackImage || VideoFallback}
            alt="Video not available"
            className={`tw-object-cover tw-w-full tw-h-full ${className}`}
          />
        </div>
      ) : (
        <video
          autoPlay={true}
          loop={true}
          muted={true}
          playsInline={true}
          onError={() => setHasError(true)}
          className={`tw-object-cover tw-w-full tw-h-full ${className}`}
        >
          <source src={videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}
    </>
  );
};

export default VideoWithFallback;
